module.exports = __webpack_public_path__ + "img/mobile_map_pescara.e92bb0c8.svg";